/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 List — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviations: behoud MUI defaults (8px padding) — Tractie heeft geen eigen list-spec,
// dense blijft modifier-only (paddings via ListItem).

export const MuiListLightOverrides = {
  root: {
    listStyle: 'none' as const,
    margin: 0,
    padding: 0,
    position: 'relative' as const,
  },

  padding: {
    paddingTop: 8,
    paddingBottom: 8,
  },

  dense: {},

  subheader: {
    paddingTop: 0,
  },
} as const;

// Dark palette variant — List heeft geen kleur-specifieke styling; tokens zitten in
// ListItem (hover/selected). Geen mode-specifieke keys nodig.
export const MuiListDarkOverrides = {
  ...MuiListLightOverrides,
} as const;
